import { apiProvider } from "@/services/utilities/Provider";

/**
 * Read-only campaign access for the admin client-detail view. Campaigns are created and edited
 * only from the client portal (cyberjob_client) — the admin panel just lists them and shows a
 * read-only detail. Talks straight to the client-facing SalesManager API (no admin passthrough
 * exists yet), same as the panel already does for /Scenario and /Agent.
 */

const getByOwner = (ownerId, page = 1, pageSize = 20) =>
    apiProvider.get(`/campaign/owner/${ownerId}?page=${page}&pageSize=${pageSize}`);

const getById = (id) => apiProvider.get(`/campaign/${id}`);

const CampaignService = { getByOwner, getById };
export default CampaignService;
